import React from 'react';
import { StyleSheet, View, TouchableOpacity, ScrollView } from 'react-native';
import BaseText from '../BaseText';
import RowView from '../RowView';
import { Color, CommonProperties } from '../../styles';
import { scale } from '../../utils/scale.utils';

const MultipleSelect = ({ items = [], selected, onChange, styleProps }) => {
  return (
    <View style={styles.container}>
      <ScrollView
        horizontal={true}
        contentContainerStyle={styles.inner}
        showsHorizontalScrollIndicator={false}
      >
        <RowView style={styles.innerScroll}>
          {items.map((i) => {
            const active = i.value === selected;
            return (
              <TouchableOpacity
                key={i.value}
                onPress={() => onChange(i.value === selected ? '' : i.value)}
                style={[
                  styleProps?.option ? styleProps?.option : styles.option,
                  active
                    ? styleProps?.optionActive
                      ? styleProps?.optionActive
                      : styles.optionActive
                    : null,
                ]}
              >
                <BaseText
                  style={[
                    styleProps?.optionText ? styleProps?.optionText : styles.optionText,
                    active
                      ? styleProps?.optionTextActive
                        ? styleProps?.optionTextActive
                        : styles.optionTextActive
                      : null,
                  ]}
                >
                  {i.label}
                </BaseText>
              </TouchableOpacity>
            );
          })}
        </RowView>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    maxHeight: scale(42),
  },
  inner: {
    ...CommonProperties.my1,
    ...CommonProperties.mx3,
  },
  option: {
    backgroundColor: Color.accent,
    ...CommonProperties.py2,
    ...CommonProperties.px4,
    ...CommonProperties.borderRadius3,
    ...CommonProperties.mr3,
    ...CommonProperties.my2,
    ...CommonProperties.shadow,
  },
  optionActive: {
    backgroundColor: Color.primary,
  },
  optionText: {
    color: Color.primary,
  },
  optionTextActive: {
    color: Color.accent,
  },
});

export default MultipleSelect;
